import React from "react";
import Table from "@/components/ui/shared/table/Table";
import TableBody from "@/components/ui/shared/table/TableBody";
import TableRow from "@/components/ui/shared/table/TableRow";
import TableCell from "@/components/ui/shared/table/TableCell";
import TableHeader from "@/components/ui/shared/table/TableHeader";
import ScrollArea from "@/components/ui/shared/ScrollArea";
import clsx from "clsx";

interface TopCampaign {
  id: string
  name: string
  contactCount: number
  isActive: boolean
  triggerType: string
}

interface CampaignsTableProps {
  campaigns: TopCampaign[]
  loading?: boolean
}

const CampaignsTable: React.FC<CampaignsTableProps> = ({ campaigns, loading = false }) => {
  const formatTriggerType = (type: string): string => {
    const typeMap: Record<string, string> = {
      'contains': 'Contém',
      'starts_with': 'Inicia com',
      'any': 'Qualquer'
    }
    return typeMap[type] || type
  }

  if (loading) {
    return (
      <div className="w-full flex gap-4 flex-col">
        <h1 className="text-[24px] font-semibold text-neutral-50">Campanhas</h1>
        <div className="w-full max-h-[300px] md:max-h-[350px] border-[1px] border-[#3F3F464D] rounded-[12px] bg-[#20202040] p-4">
          <div className="flex flex-col gap-4 animate-pulse">
            {[1, 2, 3].map((i) => (
              <div key={i} className="flex items-center gap-3">
                <div className="h-4 bg-neutral-600 rounded flex-1"></div>
                <div className="h-4 bg-neutral-600 rounded w-20"></div>
              </div>
            ))}
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="w-full flex gap-4 flex-col ">
      <h1 className="text-[24px] font-semibold text-neutral-50">Campanhas</h1>
      <ScrollArea
        classNames={{
          root: "w-full max-h-[300px] md:max-h-[350px] overflow-auto border-[1px] border-[#3F3F464D] rounded-[12px] bg-[#20202040]",
        }}
      >
        <Table className="min-w-[350px]">
          <TableHeader className="border-b-[1px] border-[#3F3F464D]">
            <TableRow>
              <TableCell className="text-[20px] text-white font-semibold">
                <p className="py-2">
                  Campanha
                </p>
              </TableCell>
              <TableCell className="text-[20px] text-white font-semibold">
                Status
              </TableCell>
            </TableRow>
          </TableHeader>
          <TableBody>
            {campaigns.length === 0 ? (
              <TableRow>
                <TableCell colSpan={2} className="text-center py-8">
                  <p className="text-neutral-400">Nenhuma campanha encontrada</p>
                </TableCell>
              </TableRow>
            ) : (
              campaigns.map((campaign) => {
                return (
                  <TableRow key={campaign.id}>
                    <TableCell>
                      <div className="flex flex-col">
                        <p className="py-1 font-medium">{campaign.name}</p>
                        <p className="text-xs text-neutral-400">
                          {formatTriggerType(campaign.triggerType)} • {campaign.contactCount} contatos
                        </p>
                      </div>
                    </TableCell>
                    <TableCell>
                      <div className="flex justify-start items-center gap-2">
                        <div
                          className={clsx(
                            "w-[7px] h-[7px] rounded-full",
                            campaign.isActive ? "bg-green-500" : "bg-orange-400"
                          )}
                        ></div>
                        <p>{campaign.isActive ? "Ativa" : "Inativa"}</p>
                      </div>
                    </TableCell>
                  </TableRow>
                );
              })
            )}
          </TableBody>
        </Table>
      </ScrollArea>
    </div>
  );
};

export default CampaignsTable;

export const AssistentesData = [
  {
    name: "Campanha 1",
    value: "100",
  },
  {
    name: "Campanha 1",
    value: "100",
  },
  {
    name: "Campanha 1",
    value: "100",
  },
  {
    name: "Campanha 1",
    value: "100",
  },
  {
    name: "Campanha 1",
    value: "100",
  },
  {
    name: "Campanha 1",
    value: "100",
  },
  {
    name: "Campanha 1",
    value: "100",
  },
];
